import { z } from "zod";

// tracker→collector間の契約。/collect の受信ボディはこのunionの配列
const baseEventSchema = z.object({
  ts: z.number(), // epoch ms
  visitorId: z.string().length(16),
  sessionId: z.string().length(16),
  device: z.enum(["pc", "sp", "tablet"]),
  isNewVisitor: z.boolean(),
  refDomain: z.string().optional(),
  utm: z.record(z.string()).optional(),
  url: z.string(),
});

export const pageviewPayloadSchema = z.object({
  viewportWidth: z.number(),
  viewportHeight: z.number(),
  pageHeight: z.number(),
});

export const scrollPayloadSchema = z.object({
  maxDepthPct: z.number().min(0).max(100),
  reached: z.object({
    d25: z.boolean(),
    d50: z.boolean(),
    d75: z.boolean(),
    d90: z.boolean(),
  }),
  dwellByBucket: z.record(z.string(), z.number()), // "0-5":ms, "5-10":ms ...
});

export const sectionPayloadSchema = z.object({
  sectionKey: z.string(),
  dwellMs: z.number(),
});

export const clickPayloadSchema = z.object({
  selector: z.string(),
  relX: z.number().min(0).max(1),
  relY: z.number().min(0).max(1),
  pageX: z.number(),
  pageY: z.number(),
  isTap: z.boolean(),
});

export const movePayloadSchema = z.object({
  gridX: z.number(),
  gridY: z.number(),
});

export const goalPayloadSchema = z.object({
  goalId: z.string().uuid(),
  goalKey: z.string(), // ga4EventName/selector/url/customキーいずれかの発火元識別用
});

export const expPayloadSchema = z.object({
  experimentId: z.string().uuid(),
  variantId: z.string().uuid(),
});

export const trackerEventSchema = z.discriminatedUnion("type", [
  baseEventSchema.extend({ type: z.literal("pageview"), payload: pageviewPayloadSchema }),
  baseEventSchema.extend({ type: z.literal("scroll"), payload: scrollPayloadSchema }),
  baseEventSchema.extend({ type: z.literal("section"), payload: sectionPayloadSchema }),
  baseEventSchema.extend({ type: z.literal("click"), payload: clickPayloadSchema }),
  baseEventSchema.extend({ type: z.literal("move"), payload: movePayloadSchema }),
  baseEventSchema.extend({ type: z.literal("goal"), payload: goalPayloadSchema }),
  baseEventSchema.extend({ type: z.literal("exp"), payload: expPayloadSchema }),
]);

export type TrackerEvent = z.infer<typeof trackerEventSchema>;

export const collectRequestSchema = z.object({
  siteKey: z.string(),
  events: z.array(trackerEventSchema).min(1).max(20),
});

export type CollectRequest = z.infer<typeof collectRequestSchema>;
